// @flow
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import AboutTemplateContainer from '../containers/about/AboutTemplateContainer';

const About = () => {
  const ldJson = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "url": "https://cacheby.com",
    "logo": "https://images.cacheby.com/logo.svg"
  }

  const ldJsonData = JSON.stringify(ldJson);

  return (
    <Fragment>
      <Helmet>
        <title>회사소개 | 캐시바이</title>
        <meta
          name="description"
          content="연구제품 전문가들에게 빠른 상담을 통해 궁금한 부분을 해결하세요. 견적서와 발주서가 없이도 제품 구매가 가능해요. 원하는 제품을 쉽게 구매하세요."
        />
        <meta name="og:title" content="회사소개 | 캐시바이" />
        <meta name="og:type" content="website" />
        <meta name="og:image" content="https://images.cacheby.com/cacheby.png" />
        <meta
          name="og:description"
          content="연구제품 전문가들에게 빠른 상담을 통해 궁금한 부분을 해결하세요. 견적서와 발주서가 없이도 제품 구매가 가능해요. 원하는 제품을 쉽게 구매하세요."
        />
        {ldJsonData && <script type="application/ld+json">{ldJsonData}</script>}
      </Helmet>
      <AboutTemplateContainer />
    </Fragment>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js